import * as commonActions from '../common/redux/actions';
import * as myAccountActions from '../my-account/redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';

import {
  AtTimeInfoModal,
  BipInfoModal,
  KuposCapsuleMenu,
  KuposCheckbox,
  KuposCounter,
  KuposErrorSuccessModal,
  KuposInput,
  KuposSuccessFailure,
  KuposTimePicker,
  SvgCircularIcons,
  SvgHome,
} from '../common';
import React, { Component } from 'react';
import { isUndefined, result } from 'lodash';

import ApiUrls from '../../services/apiUrls';
import { AppData } from '../../services';
import { BipComingSoonModal } from '../common/BipComingSoonModal';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { KuposAtCounter } from '../common/KuposAtCounter';
import KuposDatePicker from '../common/KuposDatePicker';
import { KuposDateTimePicker } from '../common/KuposDateTimePicker';
import { KuposGoModal } from '../common/KuposGoModal';
import KuposHybridInput from '../common/KuposHybridInput';
import { KuposPoolModal } from '../common/KuposPoolModal';
import KuposSelectBox from '../common/KuposSelectBox';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import at_anim from './../../images/anims/at.json';
import at_anim_white from './../../images/anims/at_white.json';
import { bindActionCreators } from 'redux';
import bip_anim from './../../images/anims/bip.json';
import bip_anim_white from './../../images/anims/bip_white.json';
import bus_anim from './../../images/anims/bus.json';
import bus_anim_white from './../../images/anims/bus_white.json';
import { connect } from 'react-redux';
import go_anim from './../../images/anims/go.json';
import go_anim_white from './../../images/anims/go_white.json';
import i18next from 'i18next';
import pool_anim from './../../images/anims/pool.json';
import pool_anim_white from './../../images/anims/pool_white.json';
import train_anim from './../../images/anims/train.json';
import train_anim_white from './../../images/anims/train_white.json';
import { withTranslation } from 'react-i18next';

// import * as actions from './redux/actions';

class HomeSearchBoxPB extends Component {
  static propTypes = {
    onwardDate: PropTypes.string,
    returnDate: PropTypes.string,
    onwardDateChange: PropTypes.func,
    returnDateChange: PropTypes.func,
    selectSourceCity: PropTypes.object,
    selectDestinationCity: PropTypes.object,
    sourceCityOptions: PropTypes.array,
    destinationCityOptions: PropTypes.array,
    sourceCityOnChange: PropTypes.func,
    destinationCityOnChange: PropTypes.func,
    onSourceInputChange: PropTypes.func,
    onDestinationInputChange: PropTypes.func,
    sourcePlaceholder: PropTypes.string,
    destinationPlaceholder: PropTypes.string,
    metaData: PropTypes.object,
    onSearch: PropTypes.func,
    t: PropTypes.func,
    onCancelPrintTicketSubmit: PropTypes.func,
    onCancelPrintTabChange: PropTypes.func,

    transferData: PropTypes.object,
    actions: PropTypes.object,
    kuposGoPostTripDetailsPending: PropTypes.bool,

    setSearchApp: PropTypes.func,
    selectedSearchApp: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.destinationRef = React.createRef();
    this.selectServiceOptions = [
      { value: 1, label: 'HOME.TO_AT' },
      { value: 2, label: 'HOME.FROM_AT' },
    ];

    this.airportListOptions = [
      { value: 1, label: 'Airport 1' },
      { value: 2, label: 'Airport 2' },
      { value: 2, label: 'Airport 3' },
    ];

    this.state = {
      capsuleMenuIcons: [
        {
          icon: '/images/icons/home/icon_print_ticket.png',
          svgIcon: 'print-ticket',
          svgPage: 'home',
          label: 'PRINT_TICKET',
        },
        {
          icon: '/images/icons/home/icon_cancel_ticket.png',
          svgIcon: 'cancel-ticket',
          svgPage: 'home',
          label: 'CANCEL_TICKET',
        },
      ],
      apps: [
        {
          name: 'PasajeBus.com',
          icon: bus_anim,
          icon_white: bus_anim_white,
          // icon: 'pasajebus',
          selected: true,
        },
        {
          name: 'EFE Trenes de Chile',
          icon: train_anim,
          icon_white: train_anim_white,
          // icon: 'train',
          selected: false,
        },
        {
          name: 'HOME.AT_NAME',
          icon: at_anim,
          icon_white: at_anim_white,
          // icon: 'transfer',
          selected: false,
        },
        {
          name: 'Recarga bip!',
          icon: bip_anim,
          icon_white: bip_anim_white,
          // icon: 'bip',
          selected: false,
        },
        {
          name: 'HOME.SPECIAL_SERVICE_COMBINED',
          icon: go_anim,
          icon_white: go_anim_white,
          // icon: 'go',
          selected: false,
        },
        {
          name: 'KuposPool',
          icon: pool_anim,
          icon_white: pool_anim_white,
          // icon: 'carpool',
          selected: false,
        },
      ],
      kuposGoSearchBody: false,
      serviceList: [
        { value: '1', label: 'HOME.SCHOOL_TRIP' },
        { value: '2', label: 'HOME.CORPORATE_TRIP' },
        { value: '3', label: 'HOME.UNIVERSITY_TRIP' },
        { value: '4', label: 'HOME.SPORTS_TRIP' },
        { value: '5', label: 'HOME.PERSONAL_TRIP' },
        { value: '6', label: 'HOME.NG_TRIP' },
        { value: '7', label: 'HOME.OTHER_TRIP' },
      ],
      vehicleList: [
        { value: '1', label: 'Bus' },
        { value: '2', label: 'Auto' },
        { value: '3', label: 'Van' },
      ],
      kuposGoSelectedService: '',
      kuposGoSelectedTransport: ' ',
      selectedKuposGoKupos: 1,
      kuposGoSelectedTime: null,
      sendRequestModal: false,
      bipInfoModalShow: false,
      kuposGoViaError: [],
      kuposGoViaReturnError: [],
      kuposGoSelectedTab: 1,
      kuposGoShowReturn: false,
      kuposGoOriginAddress: null,
      kuposGoDestinationAddress: null,
      kuposGoOriginAddressReturn: null,
      kuposGoDestinationAddressReturn: null,
      viaPointsAddress: [],
      viaPointsAddressReturn: [],
      bipCardEmail: this.props.loginData ? this.props.loginData.email : '',
      bipCardConfirmEmail: this.props.loginData ? this.props.loginData.email : '',
      atTerminals: this.props.atTerminals && this.props.atTerminals.sort().reverse(),
    };
  }

  componentDidMount() {}
  componentDidUpdate() {
    if (!this.selectOptionsUpdate && this.props.sourceCityOptions) {
      this.setState({
        selectOptions: this.props.sourceCityOptions,
      });
      this.selectOptionsUpdate = true;
    }
    if (!this.selectOptions2Update && this.props.destinationCityOptions) {
      this.setState({
        selectOptions2: this.props.destinationCityOptions,
      });
      this.selectOptions2Update = true;
    }
    if (!this.selectOptionsTrainUpdate && this.props.sourceCityTrainOptions) {
      this.setState({
        selectOptionsTrain: this.props.sourceCityTrainOptions,
      });
      this.selectOptionsTrainUpdate = true;
    }
    if (!this.selectOptions2TrainUpdate && this.props.destinationCityTrainOptions) {
      this.setState({
        selectOptions2Train: this.props.destinationCityTrainOptions,
      });
      this.selectOptions2TrainUpdate = true;
    }
  }

  clearSelectValues = () => {
    if (this.select1) this.select1.clearValue();
    if (this.select2) this.select2.clearValue();
  };

  onInputChange = (val, type) => {
    // if(type == 'train'){
    //   let selectOptions = this.props.sourceCityTrainOptions.filter(it => {
    //     return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    //   });
    //   // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
    //   this.setState({
    //     selectOptionsTrain: (selectOptions && selectOptions.length ? selectOptions.slice(0, 100) : this.props.sourceCityTrainOptions.slice(0, 100) ),
    //   });
    // }else{
    //   let selectOptions = this.props.sourceCityOptions.filter(it => {
    //     return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    //   });
    //   // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
    //   this.setState({
    //     selectOptions: (selectOptions && selectOptions.length ? selectOptions.slice(0, 100) : this.props.sourceCityOptions.slice(0, 100) ),
    //   });
    // }
  };

  onInputChange2 = (val, type) => {
    // if(type == 'train'){
    //   let selectOptions = this.props.destinationCityTrainOptions.filter(it => {
    //     return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    //   });
    //   // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
    //   this.setState({
    //     selectOptions2Train: (selectOptions && selectOptions.length ? selectOptions.slice(0, 100) : this.props.destinationCityTrainOptions.slice(0, 100) ),
    //   });
    // }else{
    //   let selectOptions = this.props.destinationCityOptions.filter(it => {
    //     return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    //   });
    //   this.setState({
    //     selectOptions2: (selectOptions && selectOptions.length ? selectOptions.slice(0, 100) : this.props.destinationCityOptions.slice(0, 100) ),
    //   });
    // }
  };

  onKuposGoServiceInputChange = val => {
    let selectOptions = this.state.serviceList.filter(it => {
      return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    });
    // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
    this.setState({
      serviceList: selectOptions.slice(0, 100),
    });
  };

  onKuposGoTransportInputChange = val => {
    let selectOptions = this.state.vehicleList.filter(it => {
      return it.label.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    });
    // this.selectOptions = CommonService.copyObject(selectOptions.slice(0,100))
    this.setState({
      vehicleList: selectOptions.slice(0, 100),
    });
  };

  search = () => {
    let errorCount = 0;
    if (!this.props.selectSourceCity) {
      this.setState({
        sourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY',
      });
      errorCount++;
    }
    if (!this.props.selectDestinationCity) {
      this.setState({
        destinationCityError: 'VALIDATIONS.VALID_DESTINATION_CITY',
      });
      errorCount++;
    }

    // if (this.props.returnDate) {
    //   var parts = this.props.onwardDate.split('-');

    //   var d1 = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));

    //   // var forwardDate = Number(parts[0] + parts[1] + parts[2]);
    //   parts = this.props.returnDate.split('-');
    //   var d2 = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    //   // var returnDate = Number(parts[0] + parts[1] + parts[2]);

    //   if (d2 <= d1) {
    //     errorCount++;
    //     this.setState({
    //       dateErrorReturn: 'VALIDATIONS.VALID_KUPOS_RETURN_TIME',
    //     });
    //   }
    // }

    // if(!this.props.onwardDate){
    //   this.setState({
    //     dateError:'Por favor seleccione la ciudad de origen.'
    //   })
    //   errorCount++;
    // }
    if (errorCount <= 0) this.props.onSearch();
  };

  searchTransfer = () => {
    let errorCount = 0;
    // if (!this.props.transferData.selectedService) {
    //   this.setState({
    //     transferServiceError: 'VALIDATIONS.VALID_SERVICE',
    //   });
    //   errorCount++;
    // } else {
    //   this.props.transferData.selectedService.value == 2
    //     ? !this.props.transferData.selectedOrigin
    //       ? (this.setState({
    //           transferSourceCityError: 'VALIDATIONS.VALID_DESTINATION_CITY',
    //         }),
    //         errorCount++)
    //       : null
    //     : !this.props.transferData.selectedOrigin
    //     ? (this.setState({
    //         transferSourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY',
    //       }),
    //       errorCount++)
    //     : null;
    // }

    if (!this.props.transferData.selectedOrigin) {
      this.setState({
        transferSourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY',
      });
      errorCount++;
    }

    if (!this.props.transferData.selectedDestination) {
      this.setState({
        transferDestinationCityError: 'VALIDATIONS.VALID_DESTINATION_CITY',
      });
      errorCount++;
    }

    if (
      this.props.transferData.selectedOrigin &&
      this.props.transferData.selectedDestination &&
      this.props.transferData.selectedOrigin.address &&
      this.props.transferData.selectedDestination.address &&
      this.props.transferData.selectedOrigin.address ===
        this.props.transferData.selectedDestination.address
    ) {
      this.setState({
        transferDestinationCityError: 'VALIDATIONS.VALID_DESTINATION_CITY',
      });
      errorCount++;
    }
    if (!this.props.transferData.selectedStartDate || !this.props.transferData.selectedStartTime) {
      this.setState({
        transferDateError: 'VALIDATIONS.VALID_DATE',
      });
      errorCount++;
    }
    // if (!this.props.transferData.selectedTime) {
    //   this.setState({
    //     transferTimeError: 'VALIDATIONS.VALID_TIME',
    //   });
    //   errorCount++;
    // }
    if (this.props.transferData.selectedKupos < 1) {
      this.setState({
        transferKuposError: 'VALIDATIONS.VALID_KUPOS',
      });
      errorCount++;
    }

    var currentDate = new Date();

    let selectedDate = new Date(
      DateService.changeDateFormat(
        this.props.transferData.selectedStartDate,
        'dd-mm-yyyy',
        'yyyy-mm-dd',
      ) +
        'T' +
        this.props.transferData.selectedStartTime,
    );

    if (
      selectedDate.getTime() <
      currentDate.getTime() +
        1000 * Number(this.props.atBlockTime && this.props.atBlockTime[0].value)
      // currentDate.getTime() + 1000 * 60 * 60 * 4
      // selectedDate.getTime() < returnDate.getTime() + '0 : 1000 * 60 * 60 * 3'
      // (this.props.transferData.selectedService.value === 2 ? 0 : 1000 * 60 * 60 * 3)
    ) {
      this.setState({
        transferDateTimeError:
          i18next.language == 'en'
            ? 'Anticipación mínima de' +
              Number(this.props.atBlockTime && this.props.atBlockTime[0].value) / 3600 +
              ' horas'
            : 'Anticipación mínima de' +
              Number(this.props.atBlockTime && this.props.atBlockTime[0].value) / 3600 +
              ' horas',
        // transferDateTimeError: 'VALIDATIONS.VALID_LESS_TIME',
      });
      errorCount++;
    }

    //CHECK FOR VALID TIME , TIME SHOULD NOT BE EQUAL TO 00:00
    if (this.props.transferData.selectedStartTime == '00:00') {
      this.setState({
        transferDateTimeError: 'VALIDATIONS.VALID_NO_TIME',
      });
      errorCount++;
    }

    //CHECK FOR VALID TIME IN RETURN, TIME SHOULD NOT BE EQUAL TO 00:00
    if (
      this.props.transferData.selectedEndTime &&
      this.props.transferData.selectedEndTime == '00:00'
    ) {
      this.setState({
        transferReturnDateTimeError: 'VALIDATIONS.VALID_NO_TIME',
      });
      errorCount++;
    }

    // return;

    if (selectedDate && this.props.transferData.selectedEndDate) {
      let returnDate = new Date(
        DateService.changeDateFormat(
          this.props.transferData.selectedEndDate,
          'dd-mm-yyyy',
          'yyyy-mm-dd',
        ) +
          'T' +
          this.props.transferData.selectedEndTime,
      );

      if (
        returnDate.getTime() <
        selectedDate.getTime() + 1000 * 60 * 60 * 2
        // selectedDate.getTime() < returnDate.getTime() + '0 : 1000 * 60 * 60 * 3'
        // (this.props.transferData.selectedService.value === 2 ? 0 : 1000 * 60 * 60 * 3)
      ) {
        this.setState({
          transferReturnDateTimeError: 'VALIDATIONS.VALID_LESS_TIME',
        });
        errorCount++;
      }
    }

    // if(!this.props.onwardDate){
    //   this.setState({
    //     dateError:'Por favor seleccione la ciudad de origen.'
    //   })
    //   errorCount++;
    // }
    if (errorCount <= 0) {
      sessionStorage.removeItem('airportTransferSelectedServiceToBook');
      sessionStorage.removeItem('airportTransferReturnServiceToBook');
      // this.props.actions.airportTransferReturnServiceToBook(null);

      this.props.onSearchTransfer();
    }
  };

  searchTrenCentral = () => {
    let errorCount = 0;
    if (!this.props.selectSourceCity) {
      this.setState({
        sourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY',
      });
      errorCount++;
    }
    if (!this.props.selectDestinationCity) {
      this.setState({
        destinationCityError: 'VALIDATIONS.VALID_DESTINATION_CITY',
      });
      errorCount++;
    }
    // if(!this.props.onwardDate){
    //   this.setState({
    //     dateError:'Por favor seleccione la ciudad de origen.'
    //   })
    //   errorCount++;
    // }
    if (errorCount <= 0) this.props.onSearchTrenCentral();
  };

  onCapsuleTabChange = key => {
    this.props.onCancelPrintTabChange(key);
    this.setState({
      capsuleMenuAcktiveTab: this.state.capsuleMenuAcktiveTab == key ? null : key,
      cancelPrintTicketDate: null,
    });
    setTimeout(() => {
      if (this.state.capsuleMenuAcktiveTab >= 0) {
        var a = document.querySelector('#scroll-to-on-cancel-open');
        if (document.documentElement.clientHeight - a.getBoundingClientRect().bottom < 0) {
          // window.scrollTo(0,a.scrollHeight + a.clientHeight + 20)
          a.scrollIntoViewIfNeeded(false);
          // setTimeout(() => {
          //   window.scrollBy(0,100);
          // }, 200);
        } else if (!this.state.capsuleMenuAcktiveTab && this.state.capsuleMenuAcktiveTab !== 0) {
          window.scrollTo(0, 0);
        }
      }
    }, 250);
  };

  cancelDateChange = date => {
    this.setState({
      cancelDate: date,
    });
  };

  onCancelPrintTicketChange = (text, inp) => {
    if (inp == 'pnr') {
      this.setState({
        cancelPrintTicketPNRError: null,
        cancelPrintTicketPNR: text,
      });
    } else if (inp == 'email') {
      this.setState({
        cancelPrintTicketEmailError: null,
        cancelPrintTicketEmail: text,
      });
    }
  };

  onCancelPrintTicketBlur = (text, inp) => {
    if (!text) {
      if (inp == 'email') {
        this.setState({
          cancelPrintTicketEmailError: {
            message: 'VALIDATIONS.VALID_EMAIL',
          },
        });
      } else if (inp == 'pnr') {
        this.setState({
          cancelPrintTicketPNRError: {
            message: 'VALIDATIONS.VALID_RESERVATION',
          },
        });
      }
    } else if (inp == 'email') {
      if (!CommonService.isEMailValid(text)) {
        this.setState({
          cancelPrintTicketEmailError: {
            message: 'VALIDATIONS.VALID_EMAIL',
          },
        });
      }
    }
  };

  onCancelPrintTicketSubmit = () => {
    let errorCount = 0;
    if (!this.state.cancelPrintTicketPNR) {
      this.setState({
        cancelPrintTicketPNRError: {
          message: 'VALIDATIONS.VALID_RESERVATION',
        },
      });
      errorCount++;
    }
    if (!this.state.cancelPrintTicketEmail) {
      this.setState({
        cancelPrintTicketEmailError: {
          message: 'VALIDATIONS.VALID_EMAIL',
        },
      });
      errorCount++;
    } else if (!CommonService.isEMailValid(this.state.cancelPrintTicketEmail)) {
      this.setState({
        cancelPrintTicketEmailError: {
          message: 'VALIDATIONS.VALID_EMAIL',
        },
      });
      errorCount++;
    }

    if (!this.state.cancelPrintTicketDate && this.state.capsuleMenuAcktiveTab === 1) {
      this.setState({
        cancelPrintTicketDateError: {
          message: 'VALIDATIONS.VALID_DATE',
        },
      });
      errorCount++;
    }
    if (errorCount > 0) {
      return;
    }
    let path = 'travel_date=' + this.state.cancelPrintTicketDate;
    path += '&contact_info=' + this.state.cancelPrintTicketEmail;
    path += '&is_mobile_app=' + true;

    if (this.state.capsuleMenuAcktiveTab == 1) {
      path += '&do_cancel=' + true;
    }

    this.props.onCancelPrintTicketSubmit(path, this.state.cancelPrintTicketPNR);
  };

  onSourceChange = value => {
    this.setState({
      sourceCityError: null,
    });
    this.props.sourceCityOnChange(value);
    this.getOriginSelectedFilteredDestinations(
      this.state.selectOptions2,
      this.props.selectSourceCity,
    );

    // if (this.props.selectSourceCity && !this.props.selectDestinationCity||!this.props.selectSourceCity && !this.props.selectDestinationCity) {
    //   this.destinationRef.current.onMenuOpen()
    // }

    if (
      this.props.selectDestinationCity &&
      value.value === this.props.selectDestinationCity.value
    ) {
      console.log('check');
      // set The destination input to null
      this.onDestinationChange(null);
      // this.destinationRef.current.onMenuOpen()
    }

    this.destinationRef.current.onMenuOpen();
    this.destinationRef.current.select.focus();
  };

  onDestinationChange = value => {
    this.setState({
      destinationCityError: null,
    });
    this.props.destinationCityOnChange(value);
  };

  getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function(obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  getOriginSelectedFilteredDestinationsTrain = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function(obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  onKuposGoServiceChange = value => {
    this.setState({ kuposGoSelectedService: value });
  };

  onKuposGoTransportChange = value => {
    this.setState({ kuposGoSelectedTransport: value });
  };

  onTransferChange = (val, type) => {
    switch (type) {
      case 'service':
        this.setState({
          transferServiceError: null,
        });
        this.setState({ transferSourceCityError: null, transferTimeError: null });
        break;
      case 'origin':
        this.setState({
          transferSourceCityError: null,
        });
        break;
      case 'destination':
        this.setState({
          transferDestinationCityError: null,
        });
        break;
      case 'date':
        this.setState({
          transferDateError: null,
          transferTimeError: null,
        });
        break;

      case 'time':
        this.setState({
          transferTimeError: null,
        });
        break;
      case 'kupos':
        this.setState({
          transferKuposError: null,
        });
        break;

      case 'kupos_adult':
        this.setState({
          selectedAdultKupos: Number(val) < 1 ? 1 : Number(val),
          selectedKupos:
            Number(val) < 1 ? 1 : Number(val) + Number(this.state.selectedKidKupos || 0),
        });
        break;
      case 'kupos_kid':
        this.setState({
          selectedKidKupos: val < 1 ? 0 : Number(val),
          selectedKupos: Number(this.state.selectedAdultKupos || 1) + Number(val),
        });
        break;
      case 'kupos_infant':
        this.setState({ selectedInfantKupos: val < 1 ? 0 : val });
        break;

      case 'start_date':
        this.setState({
          transferDateError: null,
          transferDateTimeError: null,
        });
        break;
      case 'start_time':
        this.setState({
          transferDateTimeError: null,
        });
        break;

      case 'end_date':
        this.setState({
          transferReturnDateTimeError: null,
        });
        break;
      case 'end_time':
        this.setState({
          transferReturnDateTimeError: null,
        });
        break;

      // this.setState({ transferReturnDateTimeError: null });

      default:
        break;
    }
    // type == 'service'
    //   ? this.props.onTransferChange({ value: val.value, label: this.props.t(val.label) }, type)
    //   : type === 'kupos'
    //   ? this.props.onTransferChange(val > 7 ? 7 : val, type)
    //   : this.props.onTransferChange(val, type);

    if (type === 'origin') {
      this.props.onTransferChange(val, type);
    } else if (type === 'destination') {
      this.props.onTransferChange(val, type);
    } else if (type === 'kupos_adult' || type === 'kupos_kid') {
      this.props.onTransferChange(val, type);
      setTimeout(() => {
        this.props.onTransferChange(this.state.selectedKupos, 'kupos');
      }, 500);
    } else if (type === 'end_date') {
      this.props.onTransferChange('00:00', 'end_time');
      this.props.onTransferChange(val, type);
    } else {
      this.props.onTransferChange(val, type);
    }

    // type == 'service'
    //   ? this.props.onTransferChange({ value: val.value, label: this.props.t(val.label) }, type)
    //   : type === 'kupos_adult'
    //   ? this.props.onTransferChange(val > 7 ? 7 : val, type)
    //   : type === 'kupos_kid'
    //   ? this.props.onTransferChange(
    //       val + this.props.transferData.selectedAdultKupos > 7 ? '' : val,
    //       type,
    //     )
    //   : this.props.onTransferChange(val, type);
  };

  onKuposGoChange = (val, type, journeyType) => {
    switch (type) {
      case 'service_type':
        if (journeyType) {
          this.setState({
            kuposGoServiceTypeReturnError: null,
          });
        } else {
          this.setState({
            kuposGoServiceTypeError: null,
          });
        }
        break;
      case 'vehicle_type':
        if (journeyType) {
          this.setState({
            kuposGoVehicleTypeReturnError: null,
          });
        } else {
          this.setState({
            kuposGoVehicleTypeError: null,
          });
        }
        break;
      case 'origin':
        if (journeyType) {
          this.setState({
            kuposGoSourceCityReturnError: null,
          });
        } else {
          this.setState({
            kuposGoSourceCityError: null,
          });
        }
        break;
      case 'destination':
        if (journeyType) {
          this.setState({
            kuposGoDestinationReturnError: null,
          });
        } else {
          this.setState({
            kuposGoDestinationError: null,
          });
        }
        break;
      case 'date':
        if (journeyType) {
          this.setState({
            kuposGoDateReturnError: null,
            kuposGoTimeReturnError: null,
          });
        } else {
          this.setState({
            kuposGoDateError: null,
            kuposGoTimeError: null,
          });
        }
        break;
      case 'time':
        if (journeyType) {
          this.setState({
            kuposGoTimeReturnError: null,
            kuposGoTimeReturnError: null,
          });
        } else {
          this.setState({
            kuposGoTimeError: null,
            kuposGoTimeError: null,
          });
        }
        break;
      case 'kupos':
        if (journeyType) {
          this.setState({
            kuposGoKuposReturnError: null,
          });
        } else {
          this.setState({
            kuposGoKuposError: null,
          });
        }
        break;
      case 'name':
        this.setState({
          kuposGoNameError: null,
        });
        break;
      case 'last_name':
        this.setState({
          kuposGoLastNameError: null,
        });
        break;
      case 'email':
        this.setState({
          kuposGoEmailError: null,
        });
        break;
      case 'mobile':
        this.setState({
          kuposGoMobileError: null,
        });
        break;
      case 'via_points_data':
        if (journeyType) {
          let kuposGoViaReturnError = CommonService.copyObject(this.state.kuposGoViaReturnError);
          kuposGoViaReturnError[val.index] = null;
          this.setState({
            kuposGoViaReturnError: kuposGoViaReturnError,
          });
        } else {
          let kuposGoViaError = CommonService.copyObject(this.state.kuposGoViaError);
          kuposGoViaError[val.index] = null;
          this.setState({
            kuposGoViaError: kuposGoViaError,
          });
        }
        break;

      default:
        break;
    }

    this.props.onKuposGoChange(val, type, journeyType);
  };

  renderAppTitle = t => {
    switch (this.props.selectedSearchApp) {
      case 0:
        return (
          <div className="selection-heading">
            {t('HOME.INTERCITY_BUSSES.NORMAL')}
            <span className="bold-text">{t('HOME.INTERCITY_BUSSES.BOLD')}</span>
          </div>
        );
        break;
      case 2:
        return (
          <div className="selection-heading">
            {t('HOME.AIRPORT_TRANSFER.NORMAL')}{' '}
            <span className="bold-text">{t('HOME.AIRPORT_TRANSFER.BOLD')}</span>
          </div>
        );
        break;

      case 1:
        return (
          <div className="selection-heading">
            {t('HOME.TREN_CENTRAL.NORMAL')}
            <span className="bold-text">{t('HOME.TREN_CENTRAL.BOLD')}</span>
          </div>
        );
        break;

      case 3:
        return (
          <div className="selection-heading">
            <div className="display-flex-align-center">
              <div className="bip-nain-head">
                {t('HOME.BIP_RECHARGE.NORMAL')}{' '}
                <span className="bold-text">{t('HOME.BIP_RECHARGE.BOLD')}</span>
              </div>

              <div className="bip-offer-notice display-flex-align-center">
                <img src="/images/bip_bell.svg" />
                <span className="bold-text secondary-text font10 bip-offer-title">
                  {t('HOME.BIP_DISCOUNT')}
                </span>
              </div>
            </div>
          </div>
        );
        break;

      case 4:
        return (
          <div className="selection-heading">
            {t('HOME.SPECIAL_SERVICES.NORMAL')}
            <span className="bold-text">{t('HOME.SPECIAL_SERVICES.BOLD')}</span>
          </div>
        );
        break;
      default:
        return (
          <div className="selection-heading">
            {t('HOME.INTERCITY_BUSSES.NORMAL')}{' '}
            <span className="bold-text">{t('HOME.INTERCITY_BUSSES.BOLD')}</span>
          </div>
        );
        break;
    }
  };

  renderPasajebusInputs = t => {
    this.state.transferSourceCityError ? this.setState({ transferSourceCityError: null }) : null;
    // window.scrollTo(0, 0);
    return (
      <div
        className="home-selection-input-boxes"
        key={this.props.selectedSearchApp}
        onClick={() => this.setState({ showAtCounter: false })}
      >
        <div className="home-selection-input-box font10">
          <span className="label font11">{t('HOME.ORIGIN')}</span>
          <KuposSelectBox
            reactSelect
            selectType="origin"
            ref={instance => {
              this.select1 = instance;
            }}
            options={this.state.selectOptions}
            selectedOption={this.props.selectSourceCity}
            onChange={this.onSourceChange}
            onInputChange={this.onInputChange}
            placeholder={this.props.sourcePlaceholder}
            icon="/images/icons/home/icon_source.png"
            hideArrow={true}
            error={this.state.sourceCityError ? true : false}
            errorMessage={this.props.t(this.state.sourceCityError)}
            // placeholder={t('HOME.ORIGIN')}
            height={40}
            t={t}
          />
          {/* <div className="home-selection-input kupos-border">
              <img className="icon-size" src="./images/icons/home/icon_source.png"/> <span>Source</span>
          </div> */}
        </div>

        <div className="home-selection-input-box font10">
          <span className="label font11">{t('HOME.DESTINATION')}</span>
          <KuposSelectBox
            reactSelect
            selectType="destination"
            // ref={instance => {
            //   this.select2 = instance;
            // }}
            selectRef={this.destinationRef}
            options={
              this.props.selectSourceCity
                ? this.getOriginSelectedFilteredDestinations(
                    this.state.selectOptions2,
                    this.props.selectSourceCity,
                  )
                : []
            }
            selectedOption={this.props.selectDestinationCity}
            onChange={this.onDestinationChange}
            onInputChange={this.onInputChange2}
            placeholder={this.props.destinationPlaceholder}
            icon="/images/icons/home/icon_source2.png"
            hideArrow={true}
            error={this.state.destinationCityError ? true : false}
            errorMessage={this.props.t(this.state.destinationCityError)}
            // placeholder={t('HOME.DESTINATION')}
            height={40}
            t={t}
          />
          {/* <div className="home-selection-input kupos-border">
              <img className="icon-size" src="./images/icons/home/icon_source2.png"/> <span>Source</span>
          </div> */}
        </div>

        <div className="home-selection-input-box font10 datebox">
          <span className="label font11">{t('HOME.ONE_WAY')}</span>
          <KuposDatePicker
            selectedDate={this.props.onwardDate}
            onDateChange={date => {
              this.props.onwardDateChange(date);
              this.props.returnDate ? this.props.returnDateChange(date) : null;
            }}
            minDate={DateService.getTodayString()}
            error={this.state.dateError ? true : false}
            errorMessage={this.state.dateError}
            placeholder={t('HOME.SELECT_DATE')}
            t={t}
          />
          {/* <div className="home-selection-input kupos-border">
                <img className="icon-size" src="./images/icons/home/icon_calendar.png"/> <span>Source</span>
            </div> */}
        </div>
        <div className="home-selection-input-box font10 datebox">
          <span className="label font11">{t('HOME.ROUND_TRIP')}</span>
          <KuposDatePicker
            selectedDate={this.props.returnDate}
            onDateChange={date => this.props.returnDateChange(date)}
            minDate={this.props.onwardDate}
            placeholder={t('HOME.OPTIONAL_DATE')}
            error={this.state.dateErrorReturn ? true : false}
            errorMessage={this.state.dateErrorReturn}
            canEraseDate={true}
            t={t}
          />
          {this.props.returnDate && (
            <img
              className="pointer"
              onClick={() => this.props.returnDateChange('')}
              src={'/images/icons/cross.png'}
              style={{
                width: 12,
                height: 12,
                resizeMode: 'contain',
                position: 'absolute',
                right: 7,
                bottom: 18,
              }}
            />
          )}

          {/* <div className="home-selection-input kupos-border">
                  <img className="icon-size" src="./images/icons/home/icon_calendar.png"/> <span>Source</span>
              </div> */}
        </div>

        <div className="home-selection-input-box font12 datebox">
          <button className="kupos-button home-selection-input-button " onClick={this.search}>
            {/* <img
              className="icon-size"
              src="/images/icons/home/icon_search-white.png"
              alt={this.props.t('TRANSLATIONS.ICON_SEARCH_WHITE')}
            />{' '} */}
            <span>{t('HOME.SEARCH')}</span>
          </button>
        </div>
      </div>
    );
  };
  eraseSelectedInput = type => {
    let val = '';
    switch (type) {
      case 'origin':
        this.setState({
          atOrignText: val,
          setPickupTerminal: null,
          airportChoosen: false,
          airportChoosen: this.state.setDestinationTerminal ? true : false,
          originType: 'places',
        });
        this.props.onTransferChange(val, 'origin');
        break;
      case 'destination':
        this.setState({
          atDestinationText: val,
          airportChoosen: false,
          airportChoosen: this.state.setPickupTerminal ? true : false,
          destinationType: 'places',
          // destinationReadonly: false,
          setDestinationTerminal: null,
        });
        this.props.onTransferChange(val, 'destination');
        break;
    }
  };

  onATInputBlur = (val, type) => {
    // return;
    setTimeout(() => {
      if (type === 'origin') {
        this.setState({
          showOriginTerminalSuggestions: false,
          // showDestinationTerminalSuggestions: false,
        });
      } else {
        this.setState({
          showDestinationTerminalSuggestions: false,
          // showOriginTerminalSuggestions: false,
        });
      }
    }, 300);
  };

  onSelect = (val, type) => {
    if (type == 'origin') {
      this.setState({
        showOriginTerminalSuggestions: false,
        setPickupTerminal: val,
        atOrignText: val.airport_name,
        originType: 'text',
        airportChoosen: true,
      });

      this.props.onTransferChange(val, 'origin');
    } else {
      this.setState({
        showDestinationTerminalSuggestions: false,
        setDestinationTerminal: val,
        atDestinationText: val.airport_name,
        destinationType: 'text',
        airportChoosen: true,
      });
      this.props.onTransferChange(val, 'destination');
    }
  };

  renderATTerminals = (val, key, type) => {
    return (
      <div onClick={() => this.onSelect(val, type)}>
        <a
          // className={}
          key={key}
          className="at-terminal-item"
        >
          {/* <img src="/images/icons/home/airport-icon.png" /> */}
          {val.airport_name}
        </a>
      </div>
    );
  };

  onATInputFocus = (type, event) => {
    if (type === 'origin')
      this.setState({
        showOriginTerminalSuggestions: true,
        originType: this.state.setPickupTerminal ? 'text' : 'places',
      });
    else if (type === 'destination')
      this.setState({
        showDestinationTerminalSuggestions: true,
        destinationType: this.state.setDestinationTerminal ? 'text' : 'places',
        // destinationReadonly: this.state.setPickupTerminal ? false : true,
      });
  };

  clearDateTime = () => {
    this.props.onTransferChange(null, 'end_date');
    this.props.onTransferChange(null, 'end_time');

    this.setState({ transferReturnDateTimeError: null });
  };

  onBipDetailsChange = (val, type) => {
    switch (type) {
      case 'card_number':
        this.setState({
          bipCardNumber: CommonService.onlyNumbers(val),
          bipCardNumberError: null,
        });
        break;
      case 'card_amount':
        this.setState({ bipCardAmount: CommonService.onlyNumbers(val), bipCardAmountError: null });
        break;
      case 'email':
        this.setState({ bipCardEmail: val, bipCardEmailError: null });
        break;
      case 'confirm_email':
        this.setState({ bipCardConfirmEmail: val, bipCardConfirmEmailError: null });
        break;
    }
  };

  onBipDetailsBlur = (val, type) => {
    if (!val) {
      switch (type) {
        case 'card_number':
          this.setState({ bipCardNumberError: { message: 'VALIDATIONS.INSERT_BIP_CARD_NUMBER' } });
          break;
        case 'card_amount':
          this.setState({ bipCardAmountError: { message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT' } });
          break;
        case 'email':
          this.setState({ bipCardEmailError: { message: 'VALIDATIONS.VALID_BIP_EMAIL' } });
          break;
        case 'confirm_email':
          this.setState({
            bipCardConfirmEmailError: { message: 'VALIDATIONS.VALID_BIP_EMAIL' },
          });
          break;
      }
    } else {
      if (type == 'email' && !CommonService.isEMailValid(val)) {
        this.setState({ bipCardEmailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' } });
      } else if (type == 'confirm_email' && !CommonService.isEMailValid(val)) {
        this.setState({
          bipCardConfirmEmailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' },
        });
      } else if (type == 'confirm_email' && this.state.bipCardEmail != val) {
        this.setState({
          bipCardConfirmEmailError: { message: 'VALIDATIONS.VALID_EMAIL_MATCH' },
        });
      }
    }
  };

  searchBip = () => {
    if (this.props.loginData == null || isUndefined(this.props.loginData)) {
      // if (CommonService.isLoggedIn()) {
      this.setState({
        showSuccessFailureModal: true,
        showSuccessFailureModalStatus: false,
        showSuccessFailureModalBodyText: 'VALIDATIONS.NOT_LOGGED_IN_MESSAGE',
      });

      return;
    }
    let errorCount = 0;
    if (!this.state.bipCardNumber) {
      this.setState({ bipCardNumberError: { message: 'VALIDATIONS.INSERT_BIP_CARD_NUMBER' } });
      errorCount++;
    }
    if (!this.state.bipCardAmount) {
      this.setState({ bipCardAmountError: { message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT' } });
      errorCount++;
    }
    if (!this.state.bipCardEmail) {
      this.setState({ bipCardEmailError: { message: 'VALIDATIONS.VALID_EMAILD' } });
      errorCount++;
    }
    if (!this.state.bipCardConfirmEmail) {
      this.setState({ bipCardConfirmEmailError: { message: 'VALIDATIONS.VALID_CONFIRM_EMAIL' } });
      errorCount++;
    }
    if (!CommonService.isEMailValid(this.state.bipCardEmail)) {
      this.setState({ bipCardEmailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' } });
      errorCount++;
    }
    if (!CommonService.isEMailValid(this.state.bipCardConfirmEmail)) {
      this.setState({
        bipCardConfirmEmailError: { message: 'VALIDATIONS.VALID_EMAIL_VALIDATION' },
      });
      errorCount++;
    }

    if (errorCount > 0) {
      return;
    }

    this.props.actions
      .apiCall({
        url: AppData.BIP_URL + 'api/v1/bipValidation/' + this.state.bipCardNumber,
      })
      .then(
        res => this.onBipCardsValidationResponse(res),
        err => this.onBipCardsValidationResponse(err),
      );

    // let data = {
    //   cardNumber: this.state.bipCardNumber,
    //   amount: this.state.bipCardAmount,
    //   email: this.state.bipCardEmail,
    //   confirmEmail: this.state.bipCardConfirmEmail,
    //   isMyCard: 'adhoc',
    // };
    // this.props.actions.saveBipDetails(data);

    // this.props.onSearchBip();
  };

  onBipCardsValidationResponse = result => {
    let data = {
      cardNumber: this.state.bipCardNumber,
      amount: this.state.bipCardAmount,
      email: this.state.bipCardEmail,
      confirmEmail: this.state.bipCardConfirmEmail,
      isMyCard: 'adhoc',
    };

    if (result && result.data && result.data.success) {
      this.props.actions.saveBipDetails(data);

      // product click event of at
      CommonService.googleProductClick({
        name: data.cardNumber,
        id: data.cardNumber,
        price: data.amount,
        brand: 'bip',
        category: 'bip',
      });
      this.props.onSearchBip();
    } else {
      this.setState({
        showSuccessFailureModal: true,
        showSuccessFailureModalStatus: false,
        showSuccessFailureModalBodyText: 'VALIDATIONS.INVALID_BIP_CARD',
      });
    }
  };

  setThingsOnKuposGoSearchPress = () => {
    let errorCount = 0;
    if (!this.props.kuposGoData.selectedServiceType) {
      this.setState({ kuposGoServiceTypeError: 'VALIDATIONS.VALID_SERVICE' });
      errorCount++;
    }
    if (!this.props.kuposGoData.selectedVehicleType) {
      this.setState({ kuposGoVehicleTypeError: 'HOME.SELECT_TYPE_OF_VEHICLE' });
      errorCount++;
    }
    if (errorCount > 0) {
      return;
    }
    this.props.setSearchApp(this.props.selectedSearchApp);
    this.setState({ kuposGoSearchBody: true });
    if (CommonService.isLoggedIn(this.props.loginData)) {
      this.onKuposGoChange(this.props.loginData.name, 'name');
      this.onKuposGoChange(this.props.loginData.last_name, 'last_name');
      this.onKuposGoChange(this.props.loginData.email, 'email');
      this.onKuposGoChange(this.props.loginData.phone, 'mobile');
    }
    this.props.kuposGoExtended(true);
    document.getElementById('kupos-go').scrollIntoView();
  };

  kuposGoPointsAddressChange = (val, i, type) => {
    if (type == 2) {
      let viaPointsAddressReturn = CommonService.copyObject(viaPointsAddressReturn);
      viaPointsAddressReturn[i] = val;
      this.setState({ viaPointsAddressReturn: viaPointsAddressReturn });
    } else {
      let viaPointsAddress = CommonService.copyObject(viaPointsAddress);
      viaPointsAddress[i] = val;
      this.setState({ viaPointsAddress: viaPointsAddress });
    }
  };

  renderKuposGoReturnInputs = t => {
    return (
      <div className="kupos-go-return-inps">
        {/* <div className="bold-text">{t('RESULTS_PAGE.RETURN')}</div> */}
        <div className="kupos-go-body-row">
          <div className="home-selection-input-box font10">
            <span className="font11">{t('HOME.TYPE_OF_SERVICE')}</span>
            <KuposSelectBox
              key="kupos-go-return-1"
              ref={instance => {
                this.select3 = instance;
              }}
              options={this.state.serviceList}
              selectedOption={this.props.kuposGoData.selectedServiceTypeReturn}
              onChange={val => this.onKuposGoChange(val, 'service_type', 2)}
              onInputChange={this.onKuposGoServiceInputChange}
              placeholder="Transporte corporativo para empleados"
              // icon="/images/icons/home/icon_source.png"
              // hideArrow={true}
              error={this.state.kuposGoServiceTypeReturnError ? true : false}
              errorMessage={this.props.t(this.state.kuposGoServiceTypeReturnError)}
              height={40}
              readonly={true}
              t={t}
            />
          </div>

          <div className="home-selection-input-box font10">
            <span className="font11">{t('HOME.TYPE_OF_VEHICLE')}</span>
            <KuposSelectBox
              key="kupos-go-return-2"
              ref={instance => {
                this.select4 = instance;
              }}
              options={this.state.vehicleList}
              selectedOption={this.props.kuposGoData.selectedVehicleTypeReturn}
              onChange={val => this.onKuposGoChange(val, 'vehicle_type', 2)}
              onInputChange={this.onKuposGoTransportInputChange}
              placeholder="Sin preferencia"
              // placeholder={this.props.destinationPlaceholder}
              // icon="/images/icons/home/icon_source2.png"
              // hideArrow={true}
              error={this.state.kuposGoVehicleTypeReturnError ? true : false}
              errorMessage={this.props.t(this.state.kuposGoVehicleTypeReturnError)}
              height={40}
              readonly={true}
              t={t}
            />
          </div>

          <div className="home-selection-input-box font10 counter">
            <span className="font11">{t('HOME.PASSENGER_NO')}</span>
            <KuposCounter
              value={this.props.kuposGoData.selectedKuposReturn}
              error={this.state.kuposGoKuposReturnError ? true : false}
              errorMessage={this.state.kuposGoKuposReturnError}
              onChange={val => this.onKuposGoChange(val, 'kupos', 2)}
            />
          </div>
        </div>
        <div className="kupos-go-body-row">
          <div className="home-selection-input-box font10">
            <span className="font11">{t('HOME.ORIGIN')}</span>
            <KuposInput
              key="kupos-go-return-places-1"
              type="places"
              onTextChange={val => this.setState({ kuposGoOriginAddressReturn: val })}
              value={this.state.kuposGoOriginAddressReturn}
              onChange={val => this.onKuposGoChange(val, 'origin', 2)}
              placeholder={t('HOME.ORIGIN')}
              icon="/images/icons/home/icon_source2.png"
              error={this.state.kuposGoSourceCityReturnError ? true : false}
              errorMessage={this.props.t(this.state.kuposGoSourceCityReturnError)}
              height={40}
              fontSize={'font10'}
              // key={this.state.key}
            />
          </div>

          <div className="home-selection-input-box font10 ">
            <span className="font11">{t('HOME.TRAVEL_DATE')}</span>
            <KuposDatePicker
              selectedDate={this.props.kuposGoData.selectedDateReturn}
              onDateChange={val => this.onKuposGoChange(val, 'date', 2)}
              minDate={this.props.kuposGoData.selectedDate}
              error={this.state.kuposGoDateReturnError ? true : false}
              errorMessage={this.state.kuposGoDateReturnError}
              placeholder={t('HOME.SELECT_DATE')}
            />
          </div>

          <div className="home-selection-input-box font10 ">
            <span className="font11">{t('HOME.TRAVEL_HOUR')}</span>
            <KuposTimePicker
              value={this.props.kuposGoData.selectedTimeReturn}
              onChange={val => this.onKuposGoChange(val, 'time', 2)}
              error={this.state.kuposGoTimeReturnError ? true : false}
              errorMessage={t(this.state.kuposGoTimeReturnError)}
              placeholder={'00:00'}
              t={this.props.t}
            />
          </div>
        </div>

        {this.props.kuposGoData.viaPointsReturn.map((val, i) => (
          <div className="kupos-go-body-row-3" key={'kupos-go-return-stops-' + i}>
            <div className="home-selection-input-box font10">
              <span className="font11">Stop {i + 1}</span>
              <KuposInput
                type="places"
                onTextChange={val => this.kuposGoPointsAddressChange(val, i, 2)}
                value={
                  this.state.viaPointsAddressReturn ? this.state.viaPointsAddressReturn[i] : null
                }
                onChange={val => this.onKuposGoChange({ index: i, val: val }, 'via_points_data', 2)}
                placeholder={'Stop'}
                icon="/images/icons/home/icon_source2.png"
                error={this.state.kuposGoViaReturnError[i] ? true : false}
                errorMessage={this.props.t(this.state.kuposGoViaReturnError[i])}
                height={40}
                fontSize={'font10'}
                // key={this.state.key}
              />
            </div>

            <div className="add-return-trip-kupos-go-button-container">
              <div
                className="add-stop-icon"
                // onClick={() =>
                //   this.props.onChange ? this.props.onChange(+this.props.value + 1) : null
                // }
                onClick={() => this.onKuposGoChange(i, 'add_via_points', 2)}
              >
                <SvgHome name="close" />
              </div>
            </div>
          </div>
        ))}

        {!this.props.kuposGoData.viaPointsReturn ||
        this.props.kuposGoData.viaPointsReturn.length <= 2 ? (
          <div className="display-flex add-stop-container">
            <div
              className="add-stop-icon"
              // onClick={() =>
              //   this.props.onChange ? this.props.onChange(+this.props.value + 1) : null
              // }
              onClick={() => this.onKuposGoChange(-1, 'add_via_points', 2)}
            >
              <img src="../svgs/more.svg" />
            </div>
            <span className="font11 add-stop-title">{t('HOME.ADD_STOP')}</span>
          </div>
        ) : null}

        <div className="kupos-go-body-row-2">
          <div className="home-selection-input-box font10">
            <span className="font11">{t('HOME.DESTINATION')}</span>
            <KuposInput
              key="kupos-go-return-places-2"
              type="places"
              onTextChange={val => this.setState({ kuposGoDestinationAddressReturn: val })}
              value={this.state.kuposGoDestinationAddressReturn}
              onChange={val => this.onKuposGoChange(val, 'destination', 2)}
              placeholder={t('HOME.DESTINATION')}
              icon="/images/icons/home/icon_source2.png"
              error={this.state.kuposGoDestinationReturnError ? true : false}
              errorMessage={this.props.t(this.state.kuposGoDestinationReturnError)}
              height={40}
              fontSize={'font10'}
              // key={this.state.key}
            />
          </div>

          <div className="add-return-trip-kupos-go-button-container">
            <div className="add-return-trip-kupos-go-button font12">
              <div
                className="display-flex pointer"
                onClick={() => this.setState({ kuposGoShowReturn: false, kuposGoSelectedTab: 1 })}
              >
                <img className="return-trip-icon" src="../images/add_return_trip.svg" />
                <span className="return-trip-label font11">{t('HOME.REMOVE_RETURN_TRIP')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  onKuposGoTabChange = i => {
    this.setState({ kuposGoSelectedTab: i });
  };

  renderKuposGoTabs = t => {
    return (
      <div className="recharge-tabs-container">
        <div className="map-container-selector font10">
          <div
            className={'selector-item ' + (this.state.kuposGoSelectedTab == 1 ? 'active' : '')}
            onClick={() => this.onKuposGoTabChange(1)}
          >
            {t('RESULTS_PAGE.GOING')}
          </div>
          <div
            className={'selector-item ' + (this.state.kuposGoSelectedTab == 2 ? 'active' : '')}
            onClick={() => this.onKuposGoTabChange(2)}
          >
            {t('RESULTS_PAGE.RETURN')}
          </div>
        </div>
      </div>
    );
  };

  showKuposReturnTrip = () => {
    this.setState({
      kuposGoOriginAddressReturn: this.state.kuposGoDestinationAddress,
      kuposGoDestinationAddressReturn: this.state.kuposGoOriginAddress,
      kuposGoShowReturn: true,
      returnNeeded: true,
      kuposGoSelectedTab: 2,
    });
    this.onKuposGoChange(this.props.kuposGoData.selectedServiceType, 'service_type', 2);
    this.onKuposGoChange(this.props.kuposGoData.selectedVehicleType, 'vehicle_type', 2);
    this.onKuposGoChange(this.props.kuposGoData.selectedDestination, 'origin', 2);
    this.onKuposGoChange(this.props.kuposGoData.selectedOrigin, 'destination', 2);
  };

  kuposGoIsValid = () => {
    let errorCount = 0;
    if (!this.props.kuposGoData.selectedServiceType) {
      this.setState({ kuposGoServiceTypeError: 'VALIDATIONS.VALID_SERVICE' });
      errorCount++;
    }
    if (!this.props.kuposGoData.selectedVehicleType) {
      this.setState({ kuposGoVehicleTypeError: 'HOME.SELECT_TYPE_OF_VEHICLE' });
      errorCount++;
    }
    if (!this.props.kuposGoData.selectedOrigin) {
      this.setState({
        kuposGoSourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY',
      });
      errorCount++;
    }
    if (!this.props.kuposGoData.selectedDestination) {
      this.setState({
        kuposGoDestinationError: 'VALIDATIONS.VALID_DESTINATION_CITY',
      });
      errorCount++;
    }

    let viaPoints = {};
    if (this.props.kuposGoData.viaPoints.length > 0) {
      for (let i = 0; i < this.props.kuposGoData.viaPoints.length; i++) {
        if (!this.props.kuposGoData.viaPoints[i]) {
          let kuposGoViaError = CommonService.copyObject(this.state.kuposGoViaError);
          kuposGoViaError[i] = 'VALIDATIONS.SELECT_STOP';
          this.setState({
            kuposGoViaError: kuposGoViaError,
          });
          errorCount++;
        } else {
          viaPoints[i + 1 + ''] = [
            this.props.kuposGoData.viaPoints[i].location.lat,
            this.props.kuposGoData.viaPoints[i].location.lon,
            this.props.kuposGoData.viaPoints[i].address,
          ];
        }
      }
    }

    // if (!this.props.kuposGoData.selectedTime) {
    //   this.setState({
    //     transferTimeError: 'VALIDATIONS.VALID_TIME',
    //   });
    //   errorCount++;
    // }

    // if (
    //   new Date(this.props.kuposGoData.selectedDate) <=
    //     new Date(DateService.getTodayString('dd-mm-yyyy')) &&
    //   DateService.convertTime12to24(this.props.kuposGoData.selectedTime) <=
    //     DateService.getTime(new Date(), false)
    // )

    if (
      new Date(
        DateService.changeDateFormat(
          this.props.kuposGoData.selectedDate,
          'dd-mm-yyyy',
          'yyyy-mm-dd',
        ),
      ) <= new Date() &&
      this.props.kuposGoData.selectedTime <= DateService.getTime(new Date(), false)
    ) {
      this.setState({
        kuposGoTimeError: 'VALIDATIONS.VALID_LESS_TIME',
      });
      errorCount++;
    }

    // if (
    //   new Date(this.props.kuposGoData.selectedDate) <=
    //     new Date(DateService.getTodayString('dd-mm-yyyy')) &&
    //   DateService.convertTime12to24(this.props.kuposGoData.selectedTime) <=
    //     DateService.getTime(new Date(), false)
    // ) {
    //   this.setState({
    //     kuposGoTimeError: 'Time cannot be less',
    //   });
    //   errorCount++;
    // }

    if (this.props.kuposGoData.selectedKupos < 1) {
      this.setState({
        kuposGoKuposError: 'VALIDATIONS.VALID_KUPOS',
      });
      errorCount++;
    }

    if (
      new Date(this.props.kuposGoData.selectedDate) ==
        new Date(this.props.kuposGoData.selectedDateReturn) &&
      DateService.convertTime12to24(this.props.kuposGoData.selectedTime) ==
        DateService.convertTime12to24(this.props.kuposGoData.selectedTimeReturn)
    ) {
      this.setState({
        kuposGoTimeError: 'Time cannot be same as start time',
      });
      errorCount++;
    }
    if (!this.props.kuposGoData.name) {
      this.setState({
        kuposGoNameError: 'VALIDATIONS.VALID_NAME',
      });
      errorCount++;
    }
    if (!this.props.kuposGoData.lastName) {
      this.setState({
        kuposGoLastNameError: 'VALIDATIONS.VALID_SURNAME',
      });
      errorCount++;
    }
    if (!this.props.kuposGoData.email) {
      this.setState({
        kuposGoEmailError: 'VALIDATIONS.VALID_EMAIL',
      });
      errorCount++;
    } else if (!CommonService.isEMailValid(this.props.kuposGoData.email)) {
      this.setState({
        kuposGoEmailError: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
      });
      errorCount++;
    }
    if (!this.props.kuposGoData.mobile) {
      this.setState({
        kuposGoMobileError: 'VALIDATIONS.VALID_MOBILE',
      });
      errorCount++;
    } else if (this.props.kuposGoData.mobile.toString().length != 9) {
      this.setState({
        kuposGoMobileError: 'VALIDATIONS.VALID_MOBILE_LENGTH',
      });
      errorCount++;
    }
    if (errorCount > 0) {
      this.setState({ kuposGoSelectedTab: 1 });
      return;
    }

    let viaPointsReturn = {};
    if (this.state.returnNeeded) {
      // if (!this.props.kuposGoData.selectedTime) {
      //   this.setState({
      //     transferTimeError: 'VALIDATIONS.VALID_TIME',
      //   });
      //   errorCount++;
      // }

      let viaPointsReturn = {};
      if (this.state.kuposGoShowReturn) {
        if (!this.props.kuposGoData.selectedServiceTypeReturn) {
          this.setState({ kuposGoServiceTypeReturnError: 'VALIDATIONS.VALID_SERVICE' });
          errorCount++;
        }
        if (!this.props.kuposGoData.selectedVehicleTypeReturn) {
          this.setState({ kuposGoVehicleTypeReturnError: 'HOME.SELECT_TYPE_OF_VEHICLE' });
          errorCount++;
        }
        if (!this.props.kuposGoData.selectedOriginReturn) {
          this.setState({
            kuposGoSourceCityReturnError: 'VALIDATIONS.VALID_ORIGIN_CITY',
          });
          errorCount++;
        }
        if (!this.props.kuposGoData.selectedDestinationReturn) {
          this.setState({
            kuposGoDestinationReturnError: 'VALIDATIONS.VALID_DESTINATION_CITY',
          });
          errorCount++;
        }

        if (this.props.kuposGoData.viaPointsReturn.length > 0) {
          for (let i = 0; i < this.props.kuposGoData.viaPointsReturn.length; i++) {
            if (!this.props.kuposGoData.viaPointsReturn[i]) {
              let kuposGoViaReturnError = CommonService.copyObject(
                this.state.kuposGoViaReturnError,
              );
              kuposGoViaReturnError[i] = 'VALIDATIONS.SELECT_STOP';
              this.setState({
                kuposGoViaReturnError: kuposGoViaReturnError,
              });
              errorCount++;
            } else {
              viaPointsReturn[i + 1 + ''] = [
                this.props.kuposGoData.viaPointsReturn[i].location.lat,
                this.props.kuposGoData.viaPointsReturn[i].location.lon,
                this.props.kuposGoData.viaPointsReturn[i].address,
              ];
            }
          }
        }

        if (!this.props.kuposGoData.selectedDateReturn) {
          this.setState({
            kuposGoDateReturnError: 'VALIDATIONS.VALID_DATE',
          });
          errorCount++;
        }
        // if (!this.props.kuposGoData.selectedTime) {
        //   this.setState({
        //     transferTimeError: 'VALIDATIONS.VALID_TIME',
        //   });
        //   errorCount++;
        // }

        if (
          new Date(this.props.kuposGoData.selectedDateReturn) <=
            new Date(DateService.getTodayString('dd-mm-yyyy')) &&
          DateService.convertTime12to24(this.props.kuposGoData.selectedTimeReturn) <=
            DateService.getTime(new Date(), false)
        ) {
          // if (
          //   this.props.kuposGoData.selectedDateReturn <= DateService.getTodayString('dd-mm-yyyy') &&
          //   DateService.convertTime12to24(this.props.kuposGoData.selectedTimeReturn) <=
          //     DateService.getTime(new Date(), false)
          // )
          this.setState({
            kuposGoTimeReturnError: 'Time cannot be less',
          });
          errorCount++;
        }
        if (this.props.kuposGoData.selectedKuposReturn < 1) {
          this.setState({
            kuposGoKuposReturnError: 'VALIDATIONS.VALID_KUPOS',
          });
          errorCount++;
        }

        var parts = this.props.kuposGoData.selectedDate.split('-');
        var d1 = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));

        parts = this.props.kuposGoData.selectedDateReturn.split('-');
        var d2 = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));

        // var forwardDate = Number(parts[0] + parts[1] + parts[2]);
        // var returnDate = Number(parts[0] + parts[1] + parts[2]);

        if (d2 <= d1) {
          if (
            new Date('1/1/2020 ' + this.props.kuposGoData.selectedTimeReturn) <=
            new Date('1/1/2020 ' + this.props.kuposGoData.selectedTime)
          ) {
            errorCount++;
            this.setState({
              kuposGoTimeReturnError: 'VALIDATIONS.VALID_KUPOS_RETURN_TIME',
            });
          }
        }
        if (errorCount > 0) {
          this.setState({ kuposGoSelectedTab: 2 });
          return;
        }
      }
    }

    return true;
  };

  kuposGoPostTripDetails = () => {
    try {
      if (!this.kuposGoIsValid()) {
        return;
      }

      let viaPoints = {};
      if (this.props.kuposGoData.viaPoints.length > 0) {
        for (let i = 0; i < this.props.kuposGoData.viaPoints.length; i++) {
          if (!this.props.kuposGoData.viaPoints[i]) {
            let kuposGoViaError = CommonService.copyObject(this.state.kuposGoViaError);
            kuposGoViaError[i] = 'VALIDATIONS.SELECT_STOP';
            this.setState({
              kuposGoViaError: kuposGoViaError,
            });
            // errorCount++;
          } else {
            viaPoints[i + 1 + ''] = [
              this.props.kuposGoData.viaPoints[i].location.lat,
              this.props.kuposGoData.viaPoints[i].location.lon,
              this.props.kuposGoData.viaPoints[i].address,
            ];
          }
        }
      }

      let viaPointsReturn = {};
      if (this.state.returnNeeded) {
        if (this.props.kuposGoData.viaPointsReturn.length > 0) {
          for (let i = 0; i < this.props.kuposGoData.viaPointsReturn.length; i++) {
            if (!this.props.kuposGoData.viaPointsReturn[i]) {
              let kuposGoViaReturnError = CommonService.copyObject(
                this.state.kuposGoViaReturnError,
              );
              kuposGoViaReturnError[i] = 'VALIDATIONS.SELECT_STOP';
              this.setState({
                kuposGoViaReturnError: kuposGoViaReturnError,
              });
              // errorCount++;
            } else {
              viaPointsReturn[i + 1 + ''] = [
                this.props.kuposGoData.viaPointsReturn[i].location.lat,
                this.props.kuposGoData.viaPointsReturn[i].location.lon,
                this.props.kuposGoData.viaPointsReturn[i].address,
              ];
            }
          }
        }
      }
      let data = {
        pickup_lat: this.props.kuposGoData.selectedOrigin
          ? this.props.kuposGoData.selectedOrigin.location.lat
          : '',
        pickup_lon: this.props.kuposGoData.selectedOrigin
          ? this.props.kuposGoData.selectedOrigin.location.lon
          : '',
        pickup_address: this.props.kuposGoData.selectedOrigin
          ? this.props.kuposGoData.selectedOrigin.address
          : '',
        drop_lat: this.props.kuposGoData.selectedDestination
          ? this.props.kuposGoData.selectedDestination.location.lat
          : '',
        drop_lon: this.props.kuposGoData.selectedDestination
          ? this.props.kuposGoData.selectedDestination.location.lon
          : '',
        drop_address: this.props.kuposGoData.selectedDestination
          ? this.props.kuposGoData.selectedDestination.address
          : '',
        via_points: viaPoints,
        // "via_points": {"1": [1.88, 2.96, "Madiwala"], "2": [2.04, 3.33, "Koramangala"]},
        type_of_service: this.props.kuposGoData.selectedServiceType.label,
        vehicle_type: this.props.kuposGoData.selectedVehicleType.label,
        travel_date: this.props.kuposGoData.selectedDate,
        travel_time: this.props.kuposGoData.selectedTime,
        no_of_passengers: this.props.kuposGoData.selectedKupos,
        contact_details: {
          first_name: this.props.kuposGoData.name,
          last_name: this.props.kuposGoData.lastName,
          email: this.props.kuposGoData.email,
          phone_number: this.props.kuposGoData.mobile,
        },
        return: !this.state.kuposGoShowReturn
          ? {}
          : {
              pickup_lat: this.props.kuposGoData.selectedOriginReturn
                ? this.props.kuposGoData.selectedOriginReturn.location.lat
                : '',
              pickup_lon: this.props.kuposGoData.selectedOriginReturn
                ? this.props.kuposGoData.selectedOriginReturn.location.lon
                : '',
              pickup_address: this.props.kuposGoData.selectedOriginReturn
                ? this.props.kuposGoData.selectedOriginReturn.address
                : '',
              drop_lat: this.props.kuposGoData.selectedDestinationReturn
                ? this.props.kuposGoData.selectedDestinationReturn.location.lat
                : '',
              drop_lon: this.props.kuposGoData.selectedDestinationReturn
                ? this.props.kuposGoData.selectedDestinationReturn.location.lon
                : '',
              drop_address: this.props.kuposGoData.selectedDestinationReturn
                ? this.props.kuposGoData.selectedDestinationReturn.address
                : '',
              via_points: viaPointsReturn,
              // "via_points": {"1": [1.88, 2.96, "Madiwala"], "2": [2.04, 3.33, "Koramangala"]},
              type_of_service: this.props.kuposGoData.selectedServiceTypeReturn.label,
              vehicle_type: this.props.kuposGoData.selectedVehicleTypeReturn.label,
              travel_date: this.props.kuposGoData.selectedDateReturn,
              travel_time: this.props.kuposGoData.selectedTimeReturn,
              no_of_passengers: this.props.kuposGoData.selectedKuposReturn,
            },
      };

      this.props.actions
        .kuposGoPostTripDetails({ url: ApiUrls.kuposGoPostTripDetails(), data: data })
        .then(res => {
          // this.props.setSearchApp(5);
          this.props.actions.setKuposGoData({
            selectedServiceType: null,
            selectedVehicleType: null,
            selectedOrigin: null,
            selectedDestination: null,
            selectedDate: DateService.getTodayString(),
            selectedTime: '00:00',
            selectedKupos: 1,
            viaPoints: [],
            name: null,
            lastName: null,
            email: null,
            mobile: null,
            selectedServiceTypeReturn: null,
            selectedVehicleTypeReturn: null,
            selectedOriginReturn: null,
            selectedDestinationReturn: null,
            selectedDateReturn: DateService.getTodayString(),
            selectedTimeReturn: '00:00',
            selectedKuposReturn: 1,
            viaPointsReturn: [],
          });
          this.setState({
            sendRequestModal: true,
            kuposGoShowReturn: false,
            kuposGoOriginAddress: null,
            kuposGoOriginAddressReturn: null,
            viaPointsAddress: [],
            viaPointsAddressReturn: [],
            kuposGoDestinationAddress: null,
            kuposGoDestinationAddressReturn: null,
          });
        });
    } catch (e) {
      console.log(e);
    }
  };

  setKuposGoEnvironment = key => {
    key == 4 ? this.props.kuposGoSelected(true) : this.props.kuposGoSelected(false);
    this.setState({ kuposGoSearchBody: false, kuposGoShowReturn: false, kuposGoSelectedTab: 1 });
    this.props.kuposGoExtended(false);
  };

  hideKuposGoPopup = () => {
    this.setState({ sendRequestModal: false, kuposGoSearchBody: false });
    // this.props.setSearchApp(5);
    this.props.kuposGoExtended(false);
  };

  render() {
    const { t } = this.props;
    return (
      <div
        className={
          ' content-container ' + (this.props.selectedSearchApp == 2 ? 'airport-transfer' : '')
        }
      >
        <div
          id="kupos-go"
          className={
            this.state.kuposGoSearchBody
              ? 'kupos-go-body-position kupos-card home-main-selection-container kupos-card-padding-l'
              : ' kupos-card home-main-selection-container kupos-card-padding-l'
          }
        >
          {this.renderPasajebusInputs(t)}
        </div>

        {/* cancel/print block */}

        <div className="cancel-print-container">
          {/* {this.state.capsuleMenuAcktiveTab === 0 || this.state.capsuleMenuAcktiveTab === 1 ? ( */}
          <div
            className={
              ' kupos-card print-cancel-section-home ' +
              (this.state.capsuleMenuAcktiveTab === 0 || this.state.capsuleMenuAcktiveTab === 1
                ? 'open'
                : '')
            }
          >
            <div
              onClick={() => this.onCapsuleTabChange(this.state.capsuleMenuAcktiveTab)}
              className="close-btn flex-row"
            >
              {/* <img
                  onClick={() => this.onCapsuleTabChange(this.state.capsuleMenuAcktiveTab)}
                  src="/images/icons/close-window.svg"
                /> */}
              <SvgHome name="close" />
            </div>
            <span className="bold-text font13">
              {this.state.capsuleMenuAcktiveTab === 0
                ? t('PRINT_SCREEN.PRINT_TICKET')
                : t('CANCEL_TICKET.CANCEL_TICKET')}
            </span>

            <div
              className={
                'print-cancel-subheading labels font11 ' +
                (this.state.capsuleMenuAcktiveTab === 1 ? 'cancel' : '')
              }
            >
              <span>{t('CANCEL_TICKET.RESERVATION_NUMBER')}</span>
              <span>{t('CANCEL_TICKET.EMAIL_ID')}</span>
              {this.state.capsuleMenuAcktiveTab === 1 ? (
                <span>{t('CANCEL_TICKET.TRAVEL_DATE')}</span>
              ) : null}
              <span></span>
            </div>

            <div
              className={
                'print-cancel-subheading print-cancel-home-inputs font10 ' +
                (this.state.capsuleMenuAcktiveTab === 1 ? 'cancel' : '')
              }
            >
              <KuposInput
                placeholder="Nro. PBXXXXXXXXXXX"
                type="text"
                className="kupos-border"
                value={this.state.cancelPrintTicketPNR}
                onChange={text => this.onCancelPrintTicketChange(text, 'pnr')}
                onBlur={text => this.onCancelPrintTicketBlur(text, 'pnr')}
                error={this.state.cancelPrintTicketPNRError ? true : false}
                errorMessage={
                  this.state.cancelPrintTicketPNRError
                    ? this.props.t(this.state.cancelPrintTicketPNRError.message)
                    : null
                }
              />
              <KuposInput
                placeholder="tucoreo@personal.com"
                type="email"
                className="kupos-border"
                value={this.state.cancelPrintTicketEmail}
                onChange={text => this.onCancelPrintTicketChange(text, 'email')}
                onBlur={text => this.onCancelPrintTicketBlur(text, 'email')}
                error={this.state.cancelPrintTicketEmailError ? true : false}
                errorMessage={
                  this.state.cancelPrintTicketEmailError
                    ? this.props.t(this.state.cancelPrintTicketEmailError.message)
                    : null
                }
              />
              {this.state.capsuleMenuAcktiveTab === 1 ? (
                <KuposDatePicker
                  placeholder={t('HOME.SELECT_DATE')}
                  minDate={
                    this.state.capsuleMenuAcktiveTab === 0 ? null : DateService.getTodayString()
                  }
                  selectedDate={this.state.cancelPrintTicketDate}
                  onDateChange={data =>
                    this.setState({
                      cancelPrintTicketDate: data,
                      cancelPrintTicketDateError: null,
                    })
                  }
                  error={this.state.cancelPrintTicketDateError ? true : false}
                  errorMessage={
                    this.state.cancelPrintTicketDateError
                      ? this.props.t(this.state.cancelPrintTicketDateError.message)
                      : null
                  }
                />
              ) : null}
              <button
                className="kupos-button print-cancel-button font11"
                onClick={this.onCancelPrintTicketSubmit}
              >
                <img
                  className="icon-size"
                  src="./images/icons/home/icon_print_ticket.png"
                  alt={this.props.t('TRANSLATIONS.ICON_PRINT_TICKET')}
                />{' '}
                <span className="ml-x-1">
                  {this.state.capsuleMenuAcktiveTab === 0
                    ? t('PRINT_SCREEN.PRINT')
                    : t('CANCEL_TICKET.CANCEL')}
                </span>
              </button>
            </div>

            <a className="primary-text less-bold-text font10 primary-text">
              {/* {this.state.capsuleMenuAcktiveTab === 0
                  ? t('PRINT_SCREEN.PRINT_CONFIRMATION')
                  : t('CANCEL_TICKET.ARE_YOU_SURE_CANCEL_TICKET')} */}
              {t('PRINT_SCREEN.WHERE_TO_FIND_PNR')}
            </a>
            {this.state.capsuleMenuAcktiveTab === 1 ? (
              <div className="cancel-check font10">
                <KuposCheckbox
                  checked={this.state.cancelPrintTicketCheck}
                  onChange={() =>
                    this.setState({
                      cancelPrintTicketCheck: !this.state.cancelPrintTicketCheck,
                    })
                  }
                  label={t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID')}
                />
              </div>
            ) : null}
          </div>
          {/* ) : null} */}
        </div>

        <KuposGoModal
          showModal={this.state.sendRequestModal}
          onHide={() => this.hideKuposGoPopup()}
          image={t('HOME.KUPOS_POOL_IMAGE')}
          metaData={this.props.metaData}
          t={this.props.t}
        />

        <BipInfoModal
          showModal={this.state.bipInfoModalShow}
          onHide={() => this.setState({ bipInfoModalShow: false })}
          image={'/images/example_bip_card.png'}
          t={this.props.t}
        />

        <AtTimeInfoModal
          showModal={this.state.timeInfoModalShow}
          onHide={() => this.setState({ timeInfoModalShow: false })}
          timeInfo={'Tu viaje será coordinado al menos tres horas antes de la hora de recogida'}
          t={this.props.t}
        />

        <KuposPoolModal
          showModal={this.props.selectedSearchApp == 5}
          onHide={() => this.props.setSearchApp(0)}
          image={t('HOME.KUPOS_POOL_IMAGE')}
          metaData={this.props.metaData}
          t={this.props.t}
          googlePlay={t('HOME.GOOGLE_PLAY_DARK')}
          appStore={t('HOME.APP_STORE_DARK')}
        />

        <BipComingSoonModal
          showModal={this.props.selectedSearchApp == 3}
          onHide={() => this.props.setSearchApp(0)}
          image={t('HOME.BIP_SOON_IMAGE')}
        />

        <KuposErrorSuccessModal
          success={this.state.showSuccessFailureModalStatus}
          showModal={this.state.showSuccessFailureModal}
          onButtonClick={() => this.setState({ showSuccessFailureModal: false })}
          bodyText={this.state.showSuccessFailureModalBodyText}
          t={this.props.t}
          title={
            this.state.showSuccessFailureModalStatus
              ? this.props.t('HOME.THANK_YOU')
              : this.props.t('HOME.WE_ARE_SORRY')
          }
          generalButton={
            this.state.showSuccessFailureModalStatus ? this.props.t('OK') : this.props.t('OK')
          }
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        // ...actions,
        ...serviceActions,
        ...myAccountActions,
        ...commonActions,
      },
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(HomeSearchBoxPB));



// WEBPACK FOOTER //
// ./src/features/home/HomeSearchBoxPB.js